module.exports = __webpack_public_path__ + "img/forgot-password-v2.c1bd2d21.svg";